export const LOGIN = "auth/login";
export const LOGOUT = "auth/logout";
export const LOGIN_ERROR = "auth/loginError";
export const LOGIN_REQUEST = "auth/loginRequest";
